document.addEventListener('variant:change', (event) => {
  const variant = event.detail?.variant;
  if (!variant) return;

  document.querySelectorAll('[data-pdp-selected-variant]').forEach((element) => {
    const index = Number(element.dataset.optionIndex);
    if (Number.isNaN(index)) return;

    const value = variant.options?.[index] ?? variant[`option${index + 1}`];
    if (!value || value === 'Default Title') return;

    element.textContent = value;
  });
});

/** SKU row: follows the selected variant and hides itself when the variant has no SKU. */
document.addEventListener('variant:change', (event) => {
  const variant = event.detail?.variant;
  if (!variant) return;

  const sku = (variant.sku || '').trim();
  document.querySelectorAll('[data-pdp-sku]').forEach((element) => {
    element.textContent = sku;
    const row = element.closest('[data-pdp-sku-row]');
    if (row) row.hidden = !sku;
  });
});

/**
 * Weight row: when the weight comes from the variant, swap it on variant change. The fetched
 * product section does not contain this section, so use the rendered HTML when it has the row
 * and otherwise compute it from the variant weight (grams) in the unit the row was rendered with.
 */
document.addEventListener('variant:change', (event) => {
  const { variant, html } = event.detail || {};
  if (!variant) return;

  document.querySelectorAll('[data-pdp-weight]').forEach((element) => {
    const updated = html?.getElementById ? html.getElementById(element.id) : null;
    if (updated) {
      element.textContent = updated.textContent;
      return;
    }

    const grams = Number(variant.weight);
    const unit = element.dataset.weightUnit;
    const perGram = { kg: 0.001, g: 1, lb: 0.00220462, oz: 0.0352740 };
    if (!grams || grams <= 0 || !perGram[unit]) return;

    const amount = Math.round(grams * perGram[unit] * 10) / 10;
    element.textContent = `${amount} ${unit}`;
  });
});
